/**
 * Screen codes — the literal `screens.code` values the permission layer
 * keys off (Layer 2c). Single source for the frontend: nav entries and
 * pages reference these so a code is never hand-typed twice.
 *
 * These MUST match the `screens.code` rows in D1 (see schema + the
 * read-only Screen Actions catalogue). Every operator screen — including
 * the IAM/Preferences config screens — has a row, so access is decided
 * purely by Layer-2c grants (no admin special-case).
 */

export const SCREENCODES = {
  DASHBOARD: 'dashboard.dashboard',
  /** Storefront visitor analytics (Kiran 2026-07-02). Tabbed page —
   *  Overview / Attribution / Real-time / Funnel / Pages / Geo /
   *  Devices / Cohorts / Fraud / Sessions. */
  DASHBOARDTRAFFIC: 'dashboard.traffic',
  PRODUCTS: 'products',
  PRODUCTVARIANTPRICING: 'product-variant-pricing',
  PRODUCTVARIANTPRICINGHISTORY: 'product-variant-pricing-history',
  PRODUCTPRICING: 'product.product-pricing',
  PRODUCTCOMPONENTS: 'product.product-components',
  PRODUCTSOLUTIONS: 'product.solutions',
  PRODUCTSOURCE: 'product.source',
  MANAGESUPPLIERS: 'manage.suppliers',
  MANUFACTURINGRAWMATERIALS: 'manufacturing.raw-materials',
  MANUFACTURINGPRICING: 'manufacturing.pricing',
  MANUFACTURINGMATERIALPURCHASES: 'manufacturing.material-purchases',
  MANUFACTURINGRAWMATERIALSTOCKHISTORY: 'manufacturing.raw-material-stock-history',
  WAREHOUSEPRODUCTSTOCKHISTORY: 'warehouse.product-stock-history',
  WAREHOUSEVARIANTSTOCKHISTORY: 'warehouse.variant-stock-history',
  WAREHOUSEPRODUCTPURCHASES: 'warehouse.product-purchases',
  MANAGEATTRIBUTES: 'manage.attributes',
  MANAGECATEGORIES: 'manage.categories',
  MANAGECUSTOMDATATYPES: 'manage.custom-data-types',
  MANAGEPURCHASES: 'manage.purchases',
  MANAGEGSTRATES: 'manage.gst-rates',
  MANAGEUNITS: 'manage.units',
  MANAGESTORES: 'manage.stores',
  MANAGEORGANISATIONS: 'manage.organisations',
  MANAGEPRODUCTSUPPLIERS: 'manage.product-suppliers',
  MANAGEMATERIALSUPPLIERS: 'manage.material-suppliers',
  IAMUSERTYPES: 'iam.user_types',
  IAMSTAFF: 'iam.staff',
  IAMSCREENACTIONS: 'iam.screen-actions',
  IAMGROUPS: 'iam.groups',
  CUSTOMERSREGISTERED: 'customers.registered',
  PREFERENCESSETTINGS: 'preferences.settings',
  PREFERENCESEMAILTEMPLATES: 'preferences.email-templates',
  PREFERENCESWEBHOOKPROVIDERS: 'preferences.webhook-providers',
  // Order Management — operator views of customer orders + returns
  // (2026-06-05). Read-only in v1; mutation actions land later.
  ORDERMANAGEMENTORDERS: 'order-management.orders',
  ORDERMANAGEMENTRETURNS: 'order-management.returns',
  /** Operator review of customer build_requests + Build click
   *  (Phase 2 of the multi-tenant pipeline, Kiran 2026-06-07). */
  ORDERMANAGEMENTBUILDREQUESTS: 'order-management.build-requests'
} as const

export type ScreenCode = (typeof SCREENCODES)[keyof typeof SCREENCODES]
